import { EDITEXPENSE_SUCCESS, EDITEXPENSE_FAIL } from '../actionTypes';

const initialState = {
    user: []
};

const EditExpenseReducer = (state = initialState, action) => {
    switch (action.type) {
        case EDITEXPENSE_SUCCESS:
            return {
                ...state,
                isLoggedIn: true,
                user: action.payload.user,
            };
        case EDITEXPENSE_FAIL:
            return {
                ...state,
                isLoggedIn: false,
                user: null,
            };
        default:
            break;
    }

    return state;
};

export default EditExpenseReducer;
